import { memo, useMemo } from 'react';
import { LoadingSkeleton } from '../../../../common/components';
import { GERENCIALES_DEBT_STATUS_VIEW_CHART } from '../../constants/gerencialesConstants';
import ArchivedContractsTable from './ArchivedContractsTable';
import ArchivedContractsCharts from './ArchivedContractsCharts';

/**
 * Renderiza el informe de motivos de baja de contratos.
 * @param {Object} props - Props del componente.
 * @param {boolean} props.loading - Estado de carga.
 * @param {Object|null} props.results - Resultados del reporte.
 * @param {Object|null} props.header - Header con metadata.
 * @param {string} props.reportView - Vista seleccionada (tabla/grafico).
 * @param {Object} props.pagination - Datos de paginación.
 * @param {Function} props.onPageChange - Handler de página.
 * @param {Function} props.onRowsPerPageChange - Handler de items por página.
 * @returns {JSX.Element|null} Informe de bajas.
 */
const ArchivedContractsReport = ({
  loading,
  results,
  header,
  reportView,
  pagination,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const safeResults = useMemo(
    () => results || { table: [], charts: {} },
    [results]
  );
  const tableRows = useMemo(
    () => (Array.isArray(safeResults.table) ? safeResults.table : []),
    [safeResults]
  );
  const chartData = useMemo(() => safeResults.charts || {}, [safeResults]);

  if (loading) {
    return <LoadingSkeleton />;
  }

  if (!results) {
    return null;
  }

  if (reportView === GERENCIALES_DEBT_STATUS_VIEW_CHART) {
    return <ArchivedContractsCharts chartData={chartData} header={header} />;
  }

  return (
    <ArchivedContractsTable
      rows={tableRows}
      pagination={pagination}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  );
};

export default memo(ArchivedContractsReport);
